import { useQuery } from '@tanstack/react-query';

import { catalogService } from '../services/catalog.service';
/**
 * Recupera los valores de un catálogo especificado
 *
 * @param {string} parent Valor del registgro padre por recuperar
 * @return {*} lista de valores asociados con el catálogo del catálogo
 */
export const useCatalogValueListByParent = (parent: string) => {
  return useQuery({
    queryKey: ['catalogValueByParent', parent],
    queryFn: () => catalogService.listCatalogValuesByParent(parent)
  });
};
